import { CommonCallout } from 'components/common/callouts';
import { useMachinesPortalStore } from 'components/sections/admin-portal/machines/store/use-machines-portal-store';
import { RADIX } from 'lib_ts/enums/radix-ui';

interface IProps {
  machineIDs: string[];
}

export const ActiveUsersCallout = ({ machineIDs }: IProps) => {
  const machines = useMachinesPortalStore((s) => s.machines);

  const hasActive = machines.filter(
    (machine) =>
      !!machine.active && machineIDs.some((id) => id === machine.machineID)
  );

  if (!hasActive.length) {
    return null;
  }

  let warning = `**${hasActive[0].machineID}** has an active user connected (*${hasActive[0].active?.email}*)`;

  if (hasActive.length > 1) {
    const machinesList = hasActive
      .map(({ machineID, active }) => `**${machineID}** (*${active?.email}*)`)
      .join(', ');
    warning = `The following machines currently have active users connected: ${machinesList}`;
  }

  return (
    <CommonCallout
      size="1"
      flexAlign="center"
      flexJustify="center"
      text_md={warning}
      color={RADIX.COLOR.DANGER}
    />
  );
};
